import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://vtvflmrsbyclpgunjhyg.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ0dmZsbXJzYnljbHBndW5qaHlnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM4Mzk4MjksImV4cCI6MjA4OTQxNTgyOX0.TBliKSnX7SpynBD0vc6QW8ZvpkDjA0tld7xVYoQiNss';

// Bypass Web Locks API — prevents lock-steal cascade when Supabase is slow
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    lock: (_name, _acquireTimeout, fn) => fn(),
  },
});
